import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadCaseList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/medicare/mob/organisations/${
        options.organisationId
      }/patients/${options.caseId}/cases${params ? `?${params}` : ''}`,
    );
    return result.data;
  },
};
